import React from 'react';
import SoftPhoneContactsTab from './SoftPhoneContactsTab';
import SoftPhoneRecentTab from './SoftPhoneRecentTab';

const tabClass = (active) => `flex-1 py-2.5 text-xs font-medium transition-colors ${
  active ? 'text-red-400 border-b-2 border-red-500' : 'text-slate-400 hover:text-white'
}`;

export default function SoftPhoneIdleView({ sp }) {
  return (
    <div className="flex flex-col" style={{ maxHeight: '440px' }}>
      <div className="flex border-b border-slate-700/50">
        <button data-testid="softphone-tab-contacts" onClick={() => sp.setTab('contacts')} className={tabClass(sp.tab === 'contacts')}>Contacts</button>
        <button data-testid="softphone-tab-recent" onClick={() => sp.setTab('recent')} className={tabClass(sp.tab === 'recent')}>Recents</button>
      </div>
      {sp.tab === 'contacts' && (
        <SoftPhoneContactsTab
          contacts={sp.contacts} search={sp.search} onSearchChange={sp.setSearch} isStaff={sp.isStaff}
          onCall={sp.initiateCall} onPhoneCall={sp.initiatePhoneCall} onVideoCall={sp.initiateVideoCall}
        />
      )}
      {sp.tab === 'recent' && <SoftPhoneRecentTab recentCalls={sp.recentCalls} userId={sp.user.id} />}
    </div>
  );
}
